var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageFacebook',{attrs:{"accion":_vm.accion,"item":_vm.FacebookPagina},on:{"cerrarComponente":_vm.cerrarComponente,"actualizarPagId":_vm.actualizarPagId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }